// shared/dateTimeUtils.js

// Function to format date to a readable string
export const formatDate = (date) => {
    return new Date(date).toLocaleString(); // Customize as needed
  };
  
  // Function to get the current date and time
  export const getCurrentDateTime = () => {
    return new Date().toISOString(); // Returns ISO format
  };
  
  // Function to check if a date is valid
  export const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };
